<template lang="pug">
  div
    .guide-modal(:class="{ open: showGuide }")
      a.guide-modal-close(@click="close")
        | 閉じる
      .guide-modal-title
        | （仮）活用ガイド
      hooper(ref="carousel")
        slide
          | slide 1
        slide
          | slide 2
        slide
          | slide 3
        hooper-pagination(slot="hooper-addons")
        hooper-navigation(slot="hooper-addons")
    .modal-cover
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper'
  import 'hooper/dist/hooper.css'

  export default {
    components: { Hooper, Slide, HooperPagination, HooperNavigation },
    computed: {
      ...mapGetters({
        showGuide: 'guide/showCompanyGuide',
      }),
    },
    watch: {
      showGuide () {
        this.$refs.carousel.restart()
      },
    },
    methods: {
      close () {
        this.$store.commit('guide/hideCompanyModal')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CompanyGuideModal.vue